import React, { useEffect, useState } from "react";
import IdentityDashboard from "./IdentityDashboard";
import LoomList from "../looms/LoomList";
import LoomForm from "../looms/LoomForm";
import { useLocation } from "react-router-dom";
import { IdentityCapabilities, identityRequest, identityError } from "../../services/physicalIdentityApi";

/** Keep the existing entry point; shared looms use the new association-safe flow after rollout. */
export default function PhysicalLoomRoute() {
  const location = useLocation(); const [enabled, setEnabled] = useState<boolean>(); const [error, setError] = useState("");
  useEffect(() => { let live = true; identityRequest<IdentityCapabilities>("/capabilities").then(c => { if (live) setEnabled(c.enabled && c.loom); }).catch(e => { if (live) setError(identityError(e)); }); return () => { live = false; }; }, []);
  if (error) return <p role="alert">{error} <button onClick={() => window.location.reload()}>Retry</button></p>;
  if (enabled === undefined) return <p role="status">Loading looms…</p>;
  return enabled ? <IdentityDashboard /> : location.pathname === "/looms" ? <LoomList /> : <LoomForm />;
}
